import React from 'react'

function Watch() {
  return (
    <div><br /><br /><br /><br />
        <h1 align='center'><b>watch Page</b> </h1><br /></div>
  )
}

export default Watch